import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../api/apiSlice";

const adjudicacionesAdapter = createEntityAdapter({
    selectId: (x) => x.adjudicacionId,
});


const initialState = adjudicacionesAdapter.getInitialState();


export const extendedApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getAdjudicaciones: builder.query({
            query: () => 'adjudicaciones',
            transformResponse: responseData => {
                return adjudicacionesAdapter.setAll(initialState, responseData)
            },
            providesTags: (result, error, arg) => [
                { type: 'Adjudicaciones', id: 'LIST' }
            ]
        }),

        addAdjudicaciones: builder.mutation({
            query: (newAdjudicacion) => ({
                url: 'adjudicaciones',
                method: 'post',
                body: newAdjudicacion
            }),
            invalidatesTags: ['Adjudicaciones'],
        }),

        getAdjudicacionesById: builder.query({
            query: (id) => 'adjudicaciones/' + id
        }),
        editAdjudicaciones: builder.mutation({
            query: (adjudicacionUpdated) => ({
                url: 'adjudicaciones',
                method: 'put',
                body: adjudicacionUpdated
            }),
            invalidatesTags: ['Adjudicaciones'],
        }),
        deleteAdjudicaciones: builder.mutation({
            query: (idsAdjudicacionesToDelete) => ({
                url: 'adjudicaciones',
                method: 'delete',
                body: idsAdjudicacionesToDelete
            }),
            invalidatesTags: ["Adjudicaciones"]
        }),
    })
});


export const { useGetAdjudicacionesQuery, useEditAdjudicacionesMutation, useGetCanalesAdjudicacionesQuery, useGetAdjudicacionesByIdQuery, useAddAdjudicacionesMutation, useDeleteAdjudicacionesMutation } = extendedApiSlice;

//A: returns the query result object
export const selectAdjudicacionesResult = extendedApiSlice.endpoints.getAdjudicaciones.select();

//A: created memoized selector
const selectAdjudicacionesData = createSelector(
    selectAdjudicacionesResult,
    adjudicacionesResult => adjudicacionesResult.data  //A: normalized state object with ids and entities
);


//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllAdjudicaciones,
    selectById: selectAdjudicacionById,
    selectIds: selectAdjudicacionesIds
} = adjudicacionesAdapter.getSelectors(state => selectAdjudicacionesData(state) ?? initialState);

//A:selector for get all adjudicaciones by idsList
// const selectAdjudicacionesIdsList = (state, adjudicacionesIds) => adjudicacionesIds

// export const selectadjudicacionesByIds = createSelector(
//     [selectAllAdjudicaciones, selectAdjudicacionesIdsList],
//     (adjudicaciones, adjudicacionesIds) => adjudicaciones.filter(adjudicacion => adjudicacionesIds.includes(adjudicacion.adjudicacionId)));